import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Label } from 'reactstrap';

const ColumnData = (props) => {
  const { colSize, header, value, type } = props;

  const renderSpan = () => {
    return (<span className='custom-label-value'>{value}</span>);
  };

  const renderLink = () => {
    return (
      <a
        className='custom-label-value'
        target="_blank"
        rel="noopener noreferrer"
        href={`//${value}`}>
        {value}
      </a>
    );
  };

  const renderValueElement = () => {
    if (!value) return;

    return type === 'LINK' ? renderLink() : renderSpan();
  };

  return (
    <Col xs={colSize}>
      <FormGroup>
        <Label className='custom-label'>{header}</Label>
        {renderValueElement()}
      </FormGroup>
    </Col>
  );
};

ColumnData.propTypes = {
  colKey: PropTypes.string.isRequired,
  colSize: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string
};

export default ColumnData;